var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.avatar)?_c('tk-image',{attrs:{"src":_vm.avatar,"width":_vm.size,"height":_vm.size}}):_c('div',{staticClass:"text-avatar",style:(_vm.avatarStyle)},[_vm._v(_vm._s(this.avatarString))])}
var staticRenderFns = []

export { render, staticRenderFns }